export const FETCH_GROUP_TAGS = "FETCH_GROUP_TAGS";
export const SET_GROUP_TAGS = "SET_GROUP_TAGS";
export const FETCH_TAG = "FETCH_TAG";
export const SET_TAG = "SET_TAG";
export const CREATE_TAG = "CREATE_TAG"